document.addEventListener('DOMContentLoaded', function() {
  // Get the wishlist count element
  const wishlistCountEl = document.querySelector('.wishlist-count');

  if (wishlistCountEl) {
    // Get the count as a number
    let count = parseInt(wishlistCountEl.textContent, 10);

    // Show or hide based on the count
    if (count > 0) {
      wishlistCountEl.style.display = 'inline-block';
    } else {
      wishlistCountEl.style.display = 'none';
    }
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const wishlistButtons = document.querySelectorAll('.wishlist-button');

  // Load wishlist from localStorage
  let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

  // Initialize button state on page load
  wishlistButtons.forEach(button => {
    const productId = button.getAttribute('data-product-id');

    if (wishlist.includes(productId)) {
      button.classList.add('active');
      button.querySelector('.wishlist-text').textContent = 'Added to Wishlist';
      button.querySelector('svg').setAttribute('fill', '#D5292F'); // red heart
    }
  });

  // Click handler
  wishlistButtons.forEach(button => {
    button.addEventListener('click', () => {
      const productId = button.getAttribute('data-product-id');

      if (wishlist.includes(productId)) {
        // Remove product
        wishlist = wishlist.filter(id => id !== productId);
        button.classList.remove('active');
        button.querySelector('.wishlist-text').textContent = 'Add to Wishlist';
        button.querySelector('svg').setAttribute('fill', '#ccc'); // grey heart
      } else {
        // Add product
        wishlist.push(productId);
        button.classList.add('active');
        button.querySelector('.wishlist-text').textContent = 'Added to Wishlist';
        button.querySelector('svg').setAttribute('fill', '#D5292F'); // red heart
      }

      // Save back to localStorage
      localStorage.setItem('wishlist', JSON.stringify(wishlist));

      // Update header count
      const wishlistCountEl = document.querySelector('.wishlist-count');
      if (wishlistCountEl) {
        wishlistCountEl.textContent = wishlist.length;
        wishlistCountEl.style.display = wishlist.length > 0 ? 'inline-block' : 'none';
      }
    });
  });
});


document.addEventListener('DOMContentLoaded', function () {
  const wishlistButtons = document.querySelectorAll('.wishlist-button');
  let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

  // Init button state
  wishlistButtons.forEach(button => {
    const handle = button.getAttribute('data-product-handle');
    if (wishlist.includes(handle)) {
      button.classList.add('active');
      button.querySelector('.wishlist-text').textContent = 'Added to Wishlist';
      button.querySelector('svg').setAttribute('fill', '#D5292F');
    }
  });

  

  // Click event
  wishlistButtons.forEach(button => {
    button.addEventListener('click', () => {
      const handle = button.getAttribute('data-product-handle');

      if (wishlist.includes(handle)) {
        // Remove
        wishlist = wishlist.filter(h => h !== handle);
        button.classList.remove('active');
        button.querySelector('.wishlist-text').textContent = 'Add to Wishlist';
        button.querySelector('svg').setAttribute('fill', '#ccc');
      } else {
        // Add
        wishlist.push(handle);
        button.classList.add('active');
        button.querySelector('.wishlist-text').textContent = 'Added to Wishlist';
        button.querySelector('svg').setAttribute('fill', '#D5292F');
      }

      // Save
      localStorage.setItem('wishlist', JSON.stringify(wishlist));

      // Update header count
      const wishlistCountEl = document.querySelector('.wishlist-count');
      if (wishlistCountEl) {
        wishlistCountEl.textContent = wishlist.length;
        wishlistCountEl.style.display = wishlist.length > 0 ? 'inline-block' : 'none';
      }
    });
  });

  // Wishlist page rendering
  const wishlistGrid = document.getElementById('wishlist-grid');
  if (wishlistGrid) {
    if (wishlist.length === 0) {
      wishlistGrid.innerHTML = '<p>Your wishlist is empty.</p>';
      return;
    }

    wishlist.forEach(handle => {
      fetch(`/products/${handle}?view=card`)
        .then(res => res.text())
        .then(html => {
          wishlistGrid.insertAdjacentHTML('beforeend', html);
        });
    });
  }
});
